import { useObjectUrl } from '@vueuse/core';

export function useBlobPreview(loader: () => Promise<Blob | undefined>, key: MaybeRefOrGetter<string>) {
    const blob = shallowRef<Blob>();
    const src = useObjectUrl(blob);

    const { execute, pending } = useAsyncData(
        key,
        async () => {
            blob.value = await loader();
        },
        {
            server: false,
            default: () => undefined
        }
    );

    return {
        src,
        pending,
        execute
    };
}
